
import React from "react";
import { Layout } from "@/components/layout/Layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TemplatesList } from "@/components/templates/TemplatesList";
import { TemplateForm } from "@/components/templates/TemplateForm";
import { ZapierSettings } from "@/components/templates/ZapierSettings";
import { CustomerConnect } from "@/components/templates/CustomerConnect";

const WhatsApp = () => {
  return (
    <Layout>
      <div className="h-[calc(100vh-80px)] w-full overflow-hidden p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-white mb-2">wassi.chat Templates</h1>
          <p className="text-gray-400">
            Create and manage message templates for wassi.chat. These can be used later with Zapier.
          </p>
        </div>

        <Tabs defaultValue="templates" className="w-full">
          <TabsList className="mb-6">
            <TabsTrigger value="templates">Templates</TabsTrigger>
            <TabsTrigger value="create">New Template</TabsTrigger>
            <TabsTrigger value="connect">Kundenzugang</TabsTrigger>
            <TabsTrigger value="zapier">Zapier Settings</TabsTrigger>
          </TabsList>
          
          <TabsContent value="templates">
            <TemplatesList />
          </TabsContent>
          
          <TabsContent value="create">
            <TemplateForm />
          </TabsContent>
          
          <TabsContent value="connect">
            <CustomerConnect />
          </TabsContent>
          
          <TabsContent value="zapier">
            <ZapierSettings />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
};

export default WhatsApp;
